import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class PropertyTypeTemplatesService {
  constructor(private http: HttpClient) {}

  public fetchPropertyTypeTemplates(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/propertyTypeTemplate/list`
    return this.http.post(url, params)
  }
  public fetchPropertyTypeTemplate(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/propertyTypeTemplate/${id}`
    return this.http.get(url, {})
  }

  public deletePropertyTypeTemplate(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/propertyTypeTemplate/${id}`
    return this.http.delete(url)
  }

  public createPropertyTypeTemplate(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/propertyTypeTemplate`
    return this.http.post(url, params)
  }

  public updatePropertyTypeTemplate(
    id: number,
    params: object,
  ): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/propertyTypeTemplate/${id}`
    return this.http.put(url, params)
  }
}
